import React, { useState } from "react";
import VisitorCard from "../../../../widgets/VisitorCard";
import {
  Box,
  Card,
  Grid,
  Pagination,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CustomCircularP from "../../../../widgets/CustomCircularP";
import useApiEp from "../../../../hooks/useApiEp";

const Matchmaking = () => {
  const [page, setPage] = useState(1);
  const [sq, setSq] = useState("");
  const { data, isLoading, isError, error } = useApiEp(
    `/user/get-matched-visitors?page=${page}&sq=${sq}&`
  );

  const onPageChange = (e, page) => {
    setPage(page);
  };
  const onItemSearch = (e) => {
    setSq(e.target.value);
  };

  return (
    <Box
      sx={{
        p: { xs: 2, md: 4 },
        backgroundColor: "#f8fafc",
        minHeight: "100vh",
      }}
    >
      <CustomCircularP show={isLoading} />
      <Box sx={{ mb: 4 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Typography variant="h4" fontWeight={800} color="#1e293b">
            Matched Visitors
          </Typography>
        </Box>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          B2B Matching AI seamlessly connects exhibitors with relevant visitors,
          leveraging advanced algorithms and data analysis to optimize business
          interactions during events.
        </Typography>

        <Card
          elevation={0}
          sx={{
            borderRadius: 4,
            border: "1px solid #eef2f6",
            boxShadow: "0 4px 20px rgba(0,0,0,0.03)",
            p: 3,
          }}
        >
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={2}
            alignItems="center"
          >
            <TextField
              fullWidth
              placeholder="Search Visitors..."
              variant="outlined"
              value={sq}
              onChange={onItemSearch}
              size="medium"
              sx={{
                flexGrow: 1,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  backgroundColor: "#f8fafc",
                  "&:hover fieldset": { borderColor: "#cbd5e1" },
                  "&.Mui-focused fieldset": { borderColor: "#0288d1" },
                },
              }}
            />
          </Stack>
        </Card>
      </Box>

      <Grid container spacing={3}>
        {data?.data?.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <VisitorCard item={item} />
          </Grid>
        ))}
      </Grid>

      <Box mt={2} mb={2} display={"flex"} justifyContent={"center"}>
        <Pagination
          count={Math.ceil(data?.totalItems / 30)}
          page={page}
          onChange={onPageChange}
          color="primary"
        />
      </Box>
    </Box>
  );
};

export default Matchmaking;
